
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-composeable-web.json") })
        }
      }, "path---posts-composeable-web");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---posts-composeable-web!./.cache/json/posts-composeable-web.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---posts-composeable-web!./.cache/json/posts-composeable-web.json
// module chunks = 11